import axios from "axios";
import { CentroCusto } from "models/centro_custo_type";
import { CompraSericoTypeItem, CompraType, CompraTypeItem } from "models/compras_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { ContaFinanceiro } from "models/conta_financeiro";
import { Depto } from "models/depto_type";
import { FinanceCategoryType } from "models/finance_category";
import { LancamentoFinanceiro } from "models/lancamento_type";
import { OrcamentoDepto } from "models/orcamento_departamento";
import { PessoaType } from "models/person_type";
import { UsuarioModel } from "models/user_model";
import moment from "moment";
import { useEffect, useRef, useState } from "react";

const useCompras = () => {
  const [list, setAccountTypeList] = useState<CompraType[]>([]);
  const [listDepto, setListDepto] = useState<OrcamentoDepto[]>([]);
  const [itemListServico, setListServico] = useState<CompraSericoTypeItem[]>([]);
  const [itemListServicoOld, setListServicoOld] = useState<CompraSericoTypeItem[]>([]);
  const [selectedDeptoOrcamento, setSelectedDeptoOrcamento] = useState<OrcamentoDepto>(null);
  const [itemList, setItemList] = useState<CompraTypeItem[]>([]);
  const [usuario, setUsuario] = useState<UsuarioModel>();
  const [loading, setLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [errorTitle, setErrorTitle] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [error, setError] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [accountSelected, setAccountSelected] = useState<CompraType>(null);
  const [fornecedores, setFornecedores] = useState<PessoaType[]>([]);
  const [selectedFornecedor, setSelectedFornecedor] =
    useState<PessoaType>(null);
  const [categoria, setCategoria] = useState<FinanceCategoryType[]>([]);
  const [selectedCategoria, setSelectedCategoria] =
    useState<FinanceCategoryType>(null);
  const [condicaoPagamentos, setCondicaoPagamentos] = useState<
    CondicaoPagamento[]
  >([]);
  const [selectedCondicaoPagamentos, setSelectedCondicaoPagamentos] =
    useState<CondicaoPagamento>(null);
  const [users, setUsers] = useState<UsuarioModel[]>([]);
  const [selectedUser, setSelectedUser] = useState<UsuarioModel>();
  const [icms, setIcms] = useState(0);
  const [freete, setFreete] = useState(0);
  const [desc, setDesc] = useState(0);
  const [obs, setObs] = useState(null);
  const [tipoRecebimento, setTipoRecebimento] = useState("");
  const [origem, setOrigem] = useState("");
  const [dataCompra, setDataCompra] = useState(new Date());
  const [dataPrevista, setDataPrevista] = useState(new Date());
  const [itemListFinanceiro, setItemListFinanceiro] = useState<
    LancamentoFinanceiro[]
  >([]);
  const [contaFinanceiroLista, setContaFinanceiroLista] = useState<
    ContaFinanceiro[]
  >([]);
  const [selectedConta, setSelectedConta] = useState<ContaFinanceiro>(null);
  const [depto, setDepto] = useState<Depto[]>([]);
  const [selectedDepto, setSelectedDepto] = useState<Depto>(null);
  const [centroCusto, setCentroCusto] = useState<CentroCusto[]>([]);
  const [selectedCentroCusto, setSelectedCentroCusto] =
    useState<CentroCusto>(null);

  const cancelRef = useRef();

  const [filiais, setFilial] = useState<PessoaType[]>();
  const [selectedFilial, setSelectedFilial] = useState<PessoaType>();

  const cleanInput = () => {
    setSelectedFornecedor(null);
    setAccountSelected(null);
    setSelectedCondicaoPagamentos(null);
    setSelectedUser(null);
    setSelectedCategoria(null);
    setObs(null);
    setDesc(0);
    setFreete(0);
    setIcms(0);
    setLoading(false);
    setItemList([]);
    setListServico([])
    setItemListFinanceiro([]);
    setListServicoOld([]);
    setSelectedCentroCusto(null);
    setSelectedConta(null);
    setSelectedDepto(null);
  };

  const showModal = (show: boolean) => {
    setShow(show);
    setError(false);
    if (!show) {
      cleanInput();
    }
  };

  const loadData = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/pedido-compra/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setAccountTypeList(response.data);
    }
  };

  const loadFornecedores = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/projeto/fornecedor/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setFornecedores(response.data);
    }
  };

  const loadCategory = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/financeiro-categoria/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setCategoria(response.data);
    }
  };

  const changeInput = (value: any, type: string) => {
    switch (type) {
      case "dataCompra":
        setDataCompra(value);
        setAccountSelected({ ...accountSelected, dataCompra: value });
        break;
      case "dataPrevista":
        setDataPrevista(value);
        setAccountSelected({ ...accountSelected, dataPrevista: value });
        break;
      case "icms":
        setAccountSelected({ ...accountSelected, icms: Number(value) });
        setIcms(Number(value));
        break;
      case "desconto":
        setAccountSelected({ ...accountSelected, desconto: Number(value) });
        setDesc(Number(value));
        break;
      case "frete":
        setAccountSelected({ ...accountSelected, frete: Number(value) });
        setFreete(Number(value));
        break;
      case "observacao":
        setAccountSelected({ ...accountSelected, observacao: value });
        setObs(value);
        break;
      case "origem":
        setAccountSelected({
          ...accountSelected,
          origem: value,
        });
        setOrigem(value);
        break;
      case "tipoRecebimento":
        setAccountSelected({ ...accountSelected, tipoRecebimento: value });
        setTipoRecebimento(value);
        break;
    }
    calculaItens(itemList, itemListServico);
  };

  const changeDepto = (item: string) => {
    const selected = depto?.find((f) => f.id === item);
    if (selected) {
      setSelectedDepto(selected);
      setCentroCusto(selected.CentroCusto);
    }
  };

  const changeConta = (item: string) => {
    const selected = contaFinanceiroLista?.find((f) => f.id === item);
    if (selected) {
      setSelectedConta(selected);
    }
  };

  const changeCentroCusto = (item: string) => {
    const selected = centroCusto?.find((f) => f.id === item);
    if (selected) {
      setSelectedCentroCusto(selected);
    }
  };

  const loadPagamento = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);

    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/condicao-pagamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setCondicaoPagamentos(response.data);
    }
  };

  const loadUsers = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/user/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setUsers(response.data);
    }
  };

  const loadDepto = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/departamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setDepto(response.data);
    }
  };

  const loadContaFinaceiro = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/conta-financeiro/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setContaFinanceiroLista(response.data);
    }
  };

  const changeFornecedor = (item: string) => {
    const selected = fornecedores?.find((f) => f.id === item);
    if (selected) {
      setSelectedFornecedor(selected);
    }
  };

  const changeCategoria = (item: string) => {
    const selected = categoria?.find((f) => f.id === item);
    if (selected) {
      setSelectedCategoria(selected);
    }
  };

  const changeCondicaoPagamento = (item: string) => {
    const selected = condicaoPagamentos?.find((f) => f.id === item);
    if (selected) {
      setSelectedCondicaoPagamentos(selected);
    }
  };

  const changeUser = (item: string) => {
    const selected = users?.find((f) => f.id === item);
    if (selected) {
      setSelectedUser(selected);
    }
  };

  const add = () => {
    showModal(true);
  };

  const validateField = (condition: any, errorMessage: string) => {
    if (!condition) {
      showError("Erro!", errorMessage);
      return false;
    }
    return true;
  };

  const validate = () => {
    let response = true;
    const total = itemListFinanceiro.reduce(
      (value, acc) => acc.valor + value,
      0
    );
    const validateItem = total < accountSelected.valor;
    response =
      validateField(
        !validateItem,
        "O valor dos lançamentos não pode ser menor do que o valor total"
      ) && response;
    response =
      validateField(
        selectedFornecedor,
        "Preencha o Campo Fornecedor Corretamente"
      ) && response;
    response =
      validateField(
        selectedUser,
        "Preencha o Campo Usuário Responsável Corretamente"
      ) && response;
    response =
      validateField(
        selectedCondicaoPagamentos,
        "Selecione a Forma de Pagamento"
      ) && response;
    response =
      validateField(selectedCategoria, "Selecione a categaria da CONTA") &&
      response;
    response =
      validateField(obs, "Preencha Corretamente  os Dados Adicionais") &&
      response;

    response =
      validateField(
        origem,
        "Preencha Corretamente o campo Origem"
      ) && response;

    response =
      validateField(
        selectedConta,
        "Preencha Corretamente a conta para baixa"
      ) && response;

    response =
      validateField(selectedCentroCusto, "Selecione o Centro de Custo") &&
      response;

    response =
      validateField(selectedDepto, "Selecione o Departamento") && response;

      response =
      validateField(
        selectedDeptoOrcamento ,
        "Preencha Corretamente o Planejamento Financeiro"
      ) && response;

    return response;

    
  };

  const edit = async (item: CompraType) => {
    showModal(true);
    setAccountSelected(item);
    const fornecedor = fornecedores.find((it) => it.id === item?.pessoaId);
    const usu = users.find((it) => it.id === item?.responsavelId);
    const frm = condicaoPagamentos.find(
      (it) => it.id === item?.condicaoPagamentoId
    );
    const categ = categoria.find((it) => it.id === item?.categoriaLancamentoId);
    const conta = contaFinanceiroLista.find((f) => f.id === item?.contaFinanceiroId);
    const dt = depto.find((d) =>  d.id === item?.centroCusto?.departamentoId);
    const ct = centroCusto.find((c) => c?.id === item?.centroCustoId);
    changeDepto(dt?.id);
    changeCentroCusto(item?.centroCustoId)
    setSelectedDepto(dt);
    setSelectedCentroCusto(ct);
    setSelectedConta(conta);
    setSelectedFornecedor(fornecedor);
    setSelectedUser(usu);
    setSelectedCondicaoPagamentos(frm);
    setSelectedCategoria(categ);
    onChangeFilial(item?.empresaSaiadaId);
    setItemList(item?.PedidoCompraItens);
    setListServicoOld(item?.PedidoCompraServicoItens)
    setListServico(item?.PedidoCompraServicoItens);
    if (item?.dataCompra) {
      setDataCompra(new Date(item?.dataCompra));
    }

    if (item?.dataPrevista) {
      setDataPrevista(new Date(item?.dataPrevista));
    }
    setObs(item?.observacao);
    setDesc(item?.desconto);
    setFreete(item?.frete);
    setIcms(item?.icms);
    setTipoRecebimento(item?.tipoRecebimento);
    setOrigem(item?.origem);
    changeDeptoOrcamento(item?.orcamentoDeptoId);
    await loadFinanceiro(item.id);
  };

  const save = async () => {
    if (validate()) {
      setLoading(false);
      if (accountSelected?.id === undefined) {
        await addRegister();
      } else {
        await updateRegister();
      }
      setLoading(false);
      showModal(false);
      cleanInput();
      await loadData();
    }

  };

  const addRegister = async () => {
    const obj  = {
      categoriaLancamentoId: selectedCategoria?.id,
      condicaoPagamentoId: selectedCondicaoPagamentos?.id,
      dataCompra: dataCompra ?? new Date(),
      dataPrevista: dataPrevista ?? new Date(),
      desconto: desc,
      frete: freete,
      icms: icms,
      idEmpresa: usuario?.idEmpresa,
      observacao: obs,
      responsavelId: selectedUser?.id,
      usuarioId: usuario?.id,
      ipi: accountSelected?.ipi,
      pessoaId: selectedFornecedor?.id,
      ordem: 0,
      valor: accountSelected?.valor,
      valorPedido: accountSelected?.valorPedido,
      centroCustoId: selectedCentroCusto.id,
      contaFinanceiroId: selectedConta.id,
      origem: origem,
      tipoRecebimento: tipoRecebimento,
      orcamentoDeptoId : selectedDeptoOrcamento.id,
      empresaSaiadaId : selectedFilial.id
    };
    console.log(obj);
    const response = await axios.post(
      process.env.REACT_APP_API_URL + "/pedido-compra",
      obj
    );

    if (response.data) {
      const item: CompraType = response.data;
      if (itemList.length > 0) {
        for (let i = 0; i < itemList.length; i++) {
          const element = itemList[i];
          const itemData = {
            novoProdutoId: element.novoProdutoId,
            pedidoCompraId: item.id,
            percentualIpi: element.percentualIpi,
            produtoNome: element.produtoNome,
            quantidade: element.quantidade,
            unidadeMedidaId: element.unidadeMedidaId,
            unidadeNome: element.unidadeNome,
            valorIpi: element.valorIpi,
            valorTotal: element.valorTotal,
            valorUn: element.valorUn,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/pedido-compra/items",
            itemData
          );
        }
      }
      if (itemListFinanceiro.length > 0) {
        for (let j = 0; j < itemListFinanceiro.length; j++) {
          const element = itemListFinanceiro[j];
          const finan = {
            acrescimo: element.acrescimo,
            competencia: new Date(),
            data: element.data,
            desconto: element.desconto,
            idEmpresa: element.idEmpresa,
            idPessoa: element.idPessoa,
            texto: `Referente a compra de ${moment(element.data).format(
              "DD/MM/yyyy"
            )} com vencimento em ${moment(element.vencimento).format(
              "DD/MM/yyyy"
            )}`,
            vencimento: element.vencimento,
            valor: element.valor,
            tipo: element.tipo,
            contaReceberId: item.id,
            tipoRecebimento: element.tipoRecebimento ?? "",
            obs: element.obs ?? ""
          };
          await axios.post(process.env.REACT_APP_API_URL + "/lancamento", finan);
        }
      }
      if(itemListServico.length > 0) {
        for (let index = 0; index < itemListServico.length; index++) {
          const element = itemListServico[index];
          const addServico: CompraSericoTypeItem ={
            ...element,
            pedidoCompraId: item.id
          }
          await axios.post( process.env.REACT_APP_API_URL + "/pedido-compra/servico/",addServico)
        }
      }
      setLoading((prev) => (prev = false));
      cleanInput();
      showModal(false);
    }
  };

  const updateRegister = async () => {
    const obj = {
      id: accountSelected?.id,
      categoriaLancamentoId: selectedCategoria?.id,
      condicaoPagamentoId: selectedCondicaoPagamentos?.id,
      dataCompra: dataCompra ?? new Date(),
      dataPrevista: dataPrevista ?? new Date(),
      desconto: desc,
      frete: freete,
      icms: icms,
      idEmpresa: usuario?.idEmpresa,
      observacao: obs,
      responsavelId: selectedUser?.id,
      usuarioId: usuario?.id,
      ipi: accountSelected?.ipi,
      pessoaId: selectedFornecedor?.id,
      ordem: accountSelected?.ordem,
      valor: accountSelected?.valor,
      valorPedido: accountSelected?.valorPedido,
      centroCustoId: selectedCentroCusto.id,
      contaFinanceiroId: selectedConta.id,
      origem: origem,
      tipoRecebimento: tipoRecebimento,
      orcamentoDeptoId : selectedDeptoOrcamento.id,
      empresaSaiadaId : selectedFilial.id
    };
    const response = await axios.patch(
      process.env.REACT_APP_API_URL + "/pedido-compra/" + accountSelected.id,
      obj
    );

    if (response.data) {
      const item: CompraType = response.data;
      if (itemList.length > 0) {
        for (let j = 0; j < accountSelected?.PedidoCompraItens?.length; j++) {
          const el = accountSelected?.PedidoCompraItens[j];
          await axios.delete(
            process.env.REACT_APP_API_URL + "/pedido-compra/items/" + el.id
          );
        }

        for (let i = 0; i < itemList.length; i++) {
          const element = itemList[i];
          const itemData = {
            novoProdutoId: element.novoProdutoId,
            pedidoCompraId: item.id,
            percentualIpi: element.percentualIpi,
            produtoNome: element.produtoNome,
            quantidade: element.quantidade,
            unidadeMedidaId: element.unidadeMedidaId,
            unidadeNome: element.unidadeNome,
            valorIpi: element.valorIpi,
            valorTotal: element.valorTotal,
            valorUn: element.valorUn,
          };
          await axios.post(
            process.env.REACT_APP_API_URL + "/pedido-compra/items",
            itemData
          );
        }

        if (accountSelected?.PedidoCompraItens.length > 0) {
          for (let index = 0; index < accountSelected?.PedidoCompraItens.length; index++) {
            const el = accountSelected?.PedidoCompraItens[index];
            try {
              axios.delete(process.env.REACT_APP_API_URL + "/lancamento/" + el.id);
            } catch (e) {
              console.log(e);
            }
          }
        }
        if(itemListServicoOld.length > 0) {
          for (let index = 0; index < itemListServicoOld.length; index++) {
            const el = itemListServicoOld[index];
            try {
              axios.delete(process.env.REACT_APP_API_URL + "/pedido-compra/servico/" + el.id);
            } catch (e) {
              console.log(e);
            }
          }
        }
      }
      if (itemListFinanceiro.length > 0) {
        for (let j = 0; j < itemListFinanceiro.length; j++) {
          const element = itemListFinanceiro[j];
          const finan = {
            acrescimo: element.acrescimo,
            competencia: element.competencia,
            data: element.data,
            desconto: element.desconto,
            idEmpresa: element.idEmpresa,
            idPessoa: element.idPessoa,
            texto: `Referente a compra de ${moment(element.data).format(
              "DD/MM/yyyy"
            )} com vencimento em ${moment(element.vencimento).format(
              "DD/MM/yyyy"
            )}`,
            vencimento: element.vencimento,
            valor: element.valor,
            tipo: element.tipo,
            contaReceberId: item.id,
            tipoRecebimento: element.tipoRecebimento ??  "",
            obs: element.obs ?? ""
          };
          await axios.post(process.env.REACT_APP_API_URL + "/lancamento", finan);
        }
      }

      if(itemListServico.length > 0) {
        for (let index = 0; index < itemListServico.length; index++) {
          const element = itemListServico[index];
          const addServico: CompraSericoTypeItem ={
            ...element,
            pedidoCompraId: item.id
          }
          await axios.post( process.env.REACT_APP_API_URL + "/pedido-compra/servico/",addServico)
        }
      }
      setLoading((prev) => (prev = false));
      cleanInput();
      showModal(false);
    }
  };

  const deletar = async () => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + "/pedido-compra/" + accountSelected?.id
    );
    if (response.data) {
      if (itemListFinanceiro.length > 0) {
        for (let index = 0; index < itemListFinanceiro.length; index++) {
          const el = itemListFinanceiro[index];
          try {
            axios.delete(process.env.REACT_APP_API_URL + "/lancamento/" + el.id);
          } catch (e) {
            console.log(e);
          }
        }
      }
      setLoading((prev) => (prev = false));
      showModal(false);
      setAccountSelected(null);
      setShowDelete(false);
      await loadData();
    }
  };

  const showDeleteModal = (item: CompraType) => {
    setShowDelete(true);
    setAccountSelected(item);
  };

  const closeDelete = () => {
    setShowDelete(false);
  };

  const closeError = () => {
    setError(false);
  };

  const showError = (title: string, msg: string) => {
    setError(true);
    setErrorTitle(title);
    setErrorMsg(msg);
  };

  const addRowItem = (item: CompraTypeItem) => {
    const itens = [...itemList];
    const existe = itens.find((a) => a.novoProdutoId === item.novoProdutoId);
    if (existe) {
      showError("Erro!", "Produto já existe na lista");
      return;
    } else {
      itens.push(item);
    }
    setItemList(itens);
    calculaItens(itens, itemListServico);
  };

  const deleteRow = (item: CompraTypeItem) => {
    const newList = itemList.filter((dt) => dt !== item);
    setItemList(newList);
    calculaItens(newList, itemListServico);
  };

  const editRow = (item: CompraTypeItem) => {
    const newItems: CompraTypeItem[] = itemList.map((existingItem) => {
      if (existingItem.novoProdutoId === item.novoProdutoId) {
        return item;
      }
      return existingItem;
    });
    setItemList(newItems);
    calculaItens(newItems, itemListServico);
  };

  const calculaItens = (newItems: CompraTypeItem[], servicoItems: CompraSericoTypeItem[]) => {
    let totalItens = 0;
    let total = 0;
    let totalIpi = 0;
    const desct = isNaN(desc) ? 0 : Number(desc);
    const frt = isNaN(freete) ? 0 : Number(freete);
    const Icms = isNaN(icms) ? 0 : Number(icms);
    newItems?.forEach((val) => {
      totalItens = totalItens + Number(val.valorTotal);
      total = total + val.valorUn * val.quantidade;
      totalIpi = totalIpi + Number(val.valorIpi);
    });
    const totalServico =  servicoItems.reduce((acc, value) => Number(value.valorTotal) + acc , 0)
    totalItens = Number(totalItens - desct + frt + Icms) + Number(totalServico);
    setAccountSelected({
      ...accountSelected,
      valorPedido: totalItens,
      valor: total,
      ipi: totalIpi,
    });
    if (totalItens > 0) {
      generateParcela(
        selectedCondicaoPagamentos?.id,
        dataCompra,
        totalItens,
        selectedFornecedor?.id,
        accountSelected?.tipoRecebimento
      );
    }
  };

  const loadFinanceiro = async (id: string) => {
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/lancamento/contasreceber/" + id
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      const newData: LancamentoFinanceiro[] = response.data;
      setItemListFinanceiro(newData);
    }
  };

  const addRowItemFinanceiro = (item: LancamentoFinanceiro) => {
    const itens = [...itemListFinanceiro];
    const existe = itens.find(
      (a) =>
        moment(a.vencimento).format("DD/MM/yyyy") ===
        moment(item.vencimento).format("DD/MM/yyyy")
    );
    if (existe) {
      showError("Erro!", "Lançamento Já Cadastrado");
    } else {
      itens.push(item);
    }
    setItemListFinanceiro(itens);
  };

  const deleteRowFinanceiro = (item: LancamentoFinanceiro) => {
    const newList = itemListFinanceiro.filter((dt) => dt !== item);
    setItemListFinanceiro(newList);
  };

  const editRowFinanceiro = (item: LancamentoFinanceiro) => {
    const newItems: LancamentoFinanceiro[] = itemListFinanceiro.map(
      (existingItem) => {
        if (
          moment(existingItem.vencimento).format("DD/MM/yyyy") ===
          moment(item.vencimento).format("DD/MM/yyyy")
        ) {
          return item;
        }
        return existingItem;
      }
    );
    setItemListFinanceiro(newItems);
  };

  const generateParcela = (
    item: string,
    vencimento: Date,
    valor: number,
    fornecedor: string,
    tipoRecebimento: string,
  ) => {
    const newList: LancamentoFinanceiro[] = [];

    const selected = condicaoPagamentos?.find((f) => f.id === item);
    const sFrn = fornecedores.find((a) => a.id === fornecedor);

    if (selected) {
      setSelectedCondicaoPagamentos(selected);
    }
    if (!vencimento) {
      showError("Erro!", "Selecione o dia de vencimento!");
      return;
    }
    if (!valor) {
      showError("Erro!", "Preencha corretamente o campo valor!");
      return;
    }

    if (!selectedFornecedor) {
      showError("Erro!", "Selecione o Favorecido!");
      return;
    }
    const valorParcela = valor / selected?.parcelas;
    const diaCorrente = moment();
    const itemDate = moment(vencimento).add({ day: 1 }).format("DD");
    for (let i = 0; i < selected?.parcelas; i++) {
      let dataParcela = moment().set("date", Number(itemDate));
      if (diaCorrente.isAfter(dataParcela)) {
        dataParcela.add({ month: 1 });
      }
      const newDate = dataParcela
        .add({ month: i })
        .format("YYYY-MM-DD")
        .toString();
      const itemData = new Date(newDate);

      const obj: LancamentoFinanceiro = {
        acrescimo: 0,
        competencia: accountSelected?.dataCompra,
        data: new Date(),
        desconto: 0,
        idEmpresa: usuario?.idEmpresa,
        idPessoa: sFrn?.id,
        marcado: false,
        pago: i === 0 && selected.baixaPrimeira ? true : false,
        texto: "",
        tipo: "1",
        valor: valorParcela,
        vencimento: itemData,
        id: "",
        contaPagarId: "",
        contaReceberId: "",
        dataPago: new Date(),
        obs: "",
        tipoRecebimento : tipoRecebimento
      };
      newList.push(obj);
    }
    setTimeout(() => {
      setItemListFinanceiro(newList);
    }, 300);
  };

  const changeDeptoOrcamento = (item: string) => {
    const selected = listDepto?.find((f) => f.id === item);
    if (selected) {
      setSelectedDeptoOrcamento(selected);;
    }
  };

  const loadOrcamentoDepto = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcament-departamento/list/" + userData?.idEmpresa
    );
    if (response.data) {
      setLoading((prev) => (prev = false));
      setListDepto(response.data);
    }
  };

  const loadEmpresas = async () => {
    const userData = JSON.parse(localStorage.getItem("user"));
    setUsuario(userData);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + "/orcamento/filial/" + userData?.idEmpresa
    );
    if (response.data) {
      setFilial(response.data);
    }
  };

  const onChangeFilial = (item: string) => {
    const selected = filiais.find((a) => a.id === item);
    if (selected) {
      setSelectedFilial(selected);
    }
  }

  const addRowItemServico = (item: CompraSericoTypeItem) => {
    const itens = [...itemListServico];
    const existe = itens.find((a) => a.produtoId === item.produtoId);
    if (existe) {
      showError("Erro!", "Produto já existe na lista");
    } else {
      itens.push(item);
    }
    setListServico(itens);
    calculaItens(itemList,itens);
  };

  const deleteRowSerico = (item: CompraSericoTypeItem) => {
    const newList = itemListServico.filter((dt) => dt !== item);
    setListServico(newList);
    calculaItens(itemList,newList);
  };

  const editRowServido = (item: CompraSericoTypeItem) => {
    const newItems: CompraSericoTypeItem[] = itemListServico.map((existingItem) => {
      if (existingItem.produtoId === item.produtoId) {
        return item;
      }
      return existingItem;
    });
    setListServico(newItems);
    calculaItens(itemList,newItems);
  };

  useEffect(() => {
    const initialize = async () => {
      await Promise.all([
        loadFornecedores(),
        loadData(),
        loadCategory(),
        loadPagamento(),
        loadUsers(),
        loadContaFinaceiro(),
        loadDepto(),
        loadOrcamentoDepto(),
        loadEmpresas()
      ]);
    };
    initialize();
  }, []);

  return {
    list,
    usuario,
    loading,
    show,
    error,
    errorMsg,
    errorTitle,
    accountSelected,
    showDelete,
    fornecedores,
    selectedFornecedor,
    selectedCategoria,
    selectedCondicaoPagamentos,
    cancelRef,
    itemList,
    edit,
    add,
    loadFornecedores,
    showError,
    closeError,
    showDeleteModal,
    closeDelete,
    categoria,
    changeFornecedor,
    changeCategoria,
    changeCondicaoPagamento,
    deletar,
    save,
    changeInput,
    showModal,
    condicaoPagamentos,
    users,
    selectedUser,
    changeUser,
    addRowItem,
    deleteRow,
    editRow,
    dataCompra,
    dataPrevista,
    editRowFinanceiro,
    deleteRowFinanceiro,
    addRowItemFinanceiro,
    itemListFinanceiro,
    changeDepto,
    changeConta,
    centroCusto,
    changeCentroCusto,
    depto,
    generateParcela,
    contaFinanceiroLista,
    selectedCentroCusto,
    selectedConta,
    selectedDepto,
    listDepto,
    selectedDeptoOrcamento,
    changeDeptoOrcamento,
    filiais,
    selectedFilial,
    onChangeFilial,
    itemListServico,
    addRowItemServico,
    editRowServido,
    deleteRowSerico,

  };
};
export default useCompras;
